// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
faq_taggol();
// accordions js end
// faq tabs toggal start
function togal_tabs (item) {
  item.addEventListener("click", () => {
     toggal_all_tabs(item.getAttribute('data-faq_content'));
  });        
}
function toggal_all_tabs(tabs_data){
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach(b => {
    if(b.getAttribute('data-faq_content') == tabs_data){
      if(b.classList.contains('is_open')){
         b.classList.remove("is_open");    
        }else{
         b.classList.add("is_open");
        }
    }else{
       b.classList.remove("is_open");
    }
  });             
}
function cm_faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
  tabs_title.forEach(togal_tabs);
}
cm_faq_taggol();
// faq tabs toggal end

//newsletter popup
setTimeout(function(){
  var lastShownTime = localStorage.getItem('popupLastShownTime');
  var currentTime = new Date().getTime();
  var oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  console.log(!lastShownTime || (currentTime - lastShownTime) > oneDay);
  if (!lastShownTime || (currentTime - lastShownTime) > oneDay) {
    $('#newsletter-popup').fadeIn();
      localStorage.setItem('popupLastShownTime', currentTime);
  }
  // if(window.location.href.includes('customer_posted=true')){
  //    $('#newsletter-popup').fadeIn();
  
  // }
  $('.close-popup').click(function() {
    $('#newsletter-popup').fadeOut();
    if(window.location.href.includes('customer_posted=true')){
       window.location.replace('/');
    }
  });
  
  $(window).click(function(event) {
    if ($(event.target).is('#newsletter-popup')) {
      $('#newsletter-popup').fadeOut();
    }
  });
},5000);
//newsletter popup end
let galleryTop;

function initSwiper() {
  const isDesktop = window.innerWidth >= 750;
  if (isDesktop && !galleryTop) {
    galleryTop = new Swiper('.collection-tag-filter-wrapper .swiper-arrow-navigation', {
      slidesPerView: 6,
      spaceBetween: 0,
      loop: false,
      loopedSlides: 3,
      autoHeight: true,
      slideToClickedSlide: true,
      arrows: false,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 0
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 0
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 0
        },
        1380: {
          slidesPerView: 6,
          spaceBetween: 0
        }
      }
    });
  } else if (!isDesktop && galleryTop) {
    galleryTop.destroy(true, true);
    galleryTop = undefined;
  }
}
initSwiper();

// Optionally re-run on resize
window.addEventListener('resize', () => {
  initSwiper();
});

// Collection Filter Tag Mobile Dropdown JS
const menu = document.querySelector(".collection-tag-filter-wrapper");
if (menu) {
  const [selectBtn, sBtnText] = [menu.querySelector(".select-btn"), menu.querySelector(".tag-title")];
  
  selectBtn.onclick = () => menu.classList.toggle("active");
  
  menu.querySelectorAll(".collection-tag-filter-item").forEach(option => {
    option.onclick = () => {
      sBtnText.innerText = option.querySelector(".tag-title span").innerText;
      menu.classList.remove("active");
    };
  });
}